import { SalesHomeDashboard } from '@/components/sales/SalesHomeDashboard';

const SalesHomePage = () => <SalesHomeDashboard />;

export default SalesHomePage;
